// extracted by mini-css-extract-plugin
export var addButton = "_gs-0";
export var border = "_gs-8";
export var check = "_gs-h";
export var danger = "_gs-6";
export var dropdownContainer = "_gs-1";
export var editModalBody = "_gs-j";
export var footerContainer = "_gs-i";
export var fullWidth = "_gs-a";
export var hide = "_gs-9";
export var icon = "_gs-3";
export var input = "_gs-7";
export var inputFlex = "_gs-b";
export var inputWrapper = "_gs-c";
export var manualFocus = "_gs-5";
export var optionButton = "_gs-4";
export var pillWrapper = "_gs-e";
export var pointer = "_gs-2";
export var showOverflow = "_gs-f";
export var tagsFlex = "_gs-d";
export var xButton = "_gs-g";